<template>
  <div>
    <label class="label">{{ label }}</label>
    <label class="switch toggle-button">
        <input
          type="checkbox"
          :checked="value"
          @change="change"
        />
        <span class="slider round"></span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'Toggle',
  props: ['label', 'value'],
  methods: {
    change (e) {
      this.$emit('input', e.target.checked)
      this.$emit('change', e.target.checked)
    }
  }
}
</script>

<style lang="scss" scoped>
.label {
  display: block;
  font-size: $font_size_small;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;

  input {display:none;}

  /* The slider */
  .slider {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: $color5;
      -webkit-transition: .4s;
      transition: .4s;
  }

  .slider:before {
      position: absolute;
      content: "";
      height: 26px;
      width: 26px;
      left: 4px;
      bottom: 4px;
      background-color: white;
      -webkit-transition: .4s;
      transition: .4s;
  }

  input:checked + .slider {
      background-color: $color2;
  }

  input:focus + .slider {
      box-shadow: 0 0 1px $color2;
  }

  input:checked + .slider:before {
      -webkit-transform: translateX(26px);
      -ms-transform: translateX(26px);
      transform: translateX(26px);
  }

  /* Rounded sliders */
  .slider.round {
      border-radius: 34px;
  }

  .slider.round:before {
      border-radius: 50%;
  }
}
</style>
